import {
  GETVOUCHERLIST_SUCCESS,
  GETVOUCHERLIST_FAILED,
  RESET_GETVOUCHERLIST,
  LOADING_GETVOUCHERLIST,
  NETWORK_ERROR_GETVOUCHERLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetVoucherList = () => {
  return { type: RESET_GETVOUCHERLIST };
};

const getVoucherListReq = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETVOUCHERLIST });
  await partnerServices
    .post("getVoucherList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getVoucherListsuccess(res.data));
          break;
        default:
          dispatch(getVoucherListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETVOUCHERLIST,
        payload: err,
      });
    });
};
function getVoucherListsuccess(data) {
  return {
    type: GETVOUCHERLIST_SUCCESS,
    payload: data,
  };
}
function getVoucherListFailed(data) {
  return {
    type: GETVOUCHERLIST_FAILED,
    payload: data,
  };
}

export { resetGetVoucherList, getVoucherListReq };
